import { Admonition } from "#src/shared/components/admonition";

Many libraries can convert a schema into a [JSON Schema](https://json-schema.org/), so it can be consumed by anything that speaks JSON Schema - documentation generators, OpenAPI builders, LLM structured outputs.

We benchmark whichever API the library provides, using a small schema with a codec. Libraries that generate JSON schemas at build time (e.g. typia) are not included — there's nothing to time at runtime.

```ts
const schema = z.object({
  id: z.number(),
  name: z.string(),
  price: z.codec(z.string(), z.number(), { decode: Number, encode: String }),
});

const jsonSchema = z.toJSONSchema(schema);
```

Because of the codec, the **input** and **output** types differ (`price` is a string going in, a number coming out), and so do their JSON schemas.

### Standard JSON Schema

Some libraries also implement the [Standard JSON Schema](https://standardschema.dev/json-schema) interface, which lets a tool generate a JSON schema without specialising for each library:

```ts
const jsonSchema = personSchema["~standard"].jsonSchema.input({ target: "draft-2020-12" });
```

The **Standard JSON Schema** column shows how each library supports it:

- **Native** - the library implements it
- **Native Opt in** - implemented, but it has to be enabled first (e.g. `S.enableStandardJSONSchema()`)
- **Separate package** - a separate package implements it (e.g. `@valibot/to-json-schema`)
- **None** (blank) - nothing implements it, so only the library's own API is benchmarked

<Admonition type="note" title="Generated schemas">

Every generated schema is checked against the data it describes, but libraries don't agree on what a
JSON schema for the same type looks like - each result links to what its library generated.

</Admonition>
